'use client';

import { useCallback, useState } from 'react';
import type { SubmitEvent } from 'react';

type Step = 1 | 2;

/** StepForm 의 예상 인원 Input min/max 와 동일 */
export const PEOPLE_MIN = 1;
export const PEOPLE_MAX = 999;

export function useTwoStepLeadForm() {
  const [step, setStep] = useState<Step>(1);
  const [people, setPeople] = useState('');

  const isStep2 = step === 2;
  // Input 의 min/max 는 메시지만 띄우므로 step 이동 가드는 여기서 — 0·1000 이 넘어가면 userCount 가 유실된다
  const peopleCount = Number(people);
  const hasPeople = peopleCount >= PEOPLE_MIN && peopleCount <= PEOPLE_MAX;

  const handleStep1Submit = useCallback((e: SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!hasPeople) return;
    setStep(2);
  }, [hasPeople]);

  return {
    people,
    setPeople,
    isStep2,
    hasPeople,
    handleStep1Submit,
  };
}
